module.exports = {
  "account_page": null,
  "shopping_cart_page": null,
  "not_found_page": [
    {
      "language": "en-US",
      "slug": "/not-found",
      "robots": "index,follow"
    }
  ]
}